<template>
  <div>
    <el-dialog
      title="差评原因维护"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
      v-dialogDrag
      @close="close"
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="差评原因" prop="lameReason">
          <el-select
            v-model="dataObj.lameReason"
            clearable
            placeholder="请选择"
            class="input-width"
          >
            <el-option
              v-for="(val, key, i) in renderList.lameReason"
              :label="val"
              :value="key"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" v-preventReClick="5000" :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkAdd('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 差评原因维护弹窗
 * 功能：选中多条中差评记录后统一设置差评原因（按 platform 区分 Amazon/eBay 接口）。
 * 备注：组件 name 为 "add"，疑似复制残留命名。
 */
import { updateAmazonLameReason, updateEbayLameReason } from "@/api/user";
export default {
  name: "add",
  props: {
    // 平台id 1：Amazon；2：ebay
    platform: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    renderList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      // 按钮禁用状态（定义了未用）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
      // 维护提交数据（选中记录 id 列表/差评原因）
      dataObj: {
        idList: [],
        lameReason: "",
      },
      rules: {
        lameReason: [
          {
            required: true,
            message: "请选择原因",
            trigger: "blur",
          },
        ],
      },
    };
  },
  /** 打开弹窗时将选中的中差评记录 id 映射进提交数据 */
  created() {
    this.dataObj.idList = this.dataList.map((item) => item.id);
  },
  methods: {
    /** 关闭弹窗并通知父组件 */
    close() {
      this.dialogFormVisible = false;
      this.$emit("isShowEdit");
    },
    /** 校验表单后按平台调用差评原因更新接口，成功后关闭弹窗并刷新列表
     * @param {String} formName 表单 ref 名称
     */
    checkAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.platform === 1) {
            // Amazon中差评列表-维护差评原因
            updateAmazonLameReason(this.dataObj).then((result) => {
              if (result.code == 200) {
                this.dialogFormVisible = false;
                this.$message.success(result.msg);
                this.$emit("getList");
              }
            });
          } else {
            // ebay中差评列表-维护差评原因
            updateEbayLameReason(this.dataObj).then((result) => {
              if (result.code == 200) {
                this.dialogFormVisible = false;
                this.$message.success(result.msg);
                this.$emit("getList");
              }
            });
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>